import { Injectable } from '@angular/core';
import { Descarga } from '../models/descarga';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class DescargaService {

  constructor(
    private http: HttpClient
  ) { }

  salvar(descarga: Descarga) {
    return this.http.post(globals.apiUrl + '/api/Descarga/Salvar', descarga);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/Descarga/Excluir',
      { params: new HttpParams().set('id', id) });
  }

  consultarPorIdDescarga(idDescarga) {
    return this.http.get<any>(globals.apiUrl + '/api/Descarga/Buscar',
      { params: new HttpParams().set('id', idDescarga) });
  }

  consultarDescargas() {
    return this.http.get<Descarga[]>(globals.apiUrl + '/api/Descarga/Lista');
  }

  consultarComPaginacao(descri, paginaAtual, qtdRegistros, campoOrdenacao, asc_desc) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', asc_desc)
      .set('descri', descri ? descri : '');

    return this.http.get<any>(globals.apiUrl + '/api/Descarga/ListaPag',
      {
        params: parametros
      });
  }
}
